var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossii1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 0.625H1.375C0.960156 0.625 0.625 0.960156 0.625 1.375V18.625C0.625 19.0398 0.960156 19.375 1.375 19.375H18.625C19.0398 19.375 19.375 19.0398 19.375 18.625V1.375C19.375 0.960156 19.0398 0.625 18.625 0.625ZM17.6875 17.6875H2.3125V2.3125H17.6875V17.6875Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29706 13.7266H7.67753C7.79003 13.7266 7.8955 13.6773 7.96581 13.593L10.0002 11.1672L12.0346 13.593C12.1072 13.6773 12.2127 13.7266 12.3228 13.7266H13.7033C13.8627 13.7266 13.9494 13.5414 13.8463 13.4195L10.9799 10L13.8463 6.58047C13.9494 6.45859 13.8627 6.27344 13.7033 6.27344H12.3228C12.2103 6.27344 12.1049 6.32266 12.0346 6.40703L10.0002 8.83281L7.96581 6.40703C7.89316 6.32266 7.78769 6.27344 7.67753 6.27344H6.29706C6.13769 6.27344 6.05097 6.45859 6.15409 6.58047L9.0205 10L6.15409 13.4195C6.13099 13.4467 6.11617 13.4799 6.11139 13.5153C6.10661 13.5506 6.11207 13.5866 6.12713 13.6189C6.14218 13.6512 6.16619 13.6785 6.19631 13.6976C6.22644 13.7167 6.2614 13.7268 6.29706 13.7266Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossii1);
export default __webpack_public_path__ + "static/media/crossii1.1b5e47508f4b699a8f3679863f93bcf8.svg";
export { ForwardRef as ReactComponent };